import { FC, ComponentProps } from 'react'
import { Button } from 'components/primitives'
import { CSS } from '@stitches/react'
import { useMarketplaceChain } from 'hooks'

// OpenSea chain slugs for asset URLs. Chains without OpenSea support
// (e.g. Linea, Arbitrum Nova) return null and the button renders nothing.
const OPENSEA_CHAIN_SLUGS: Record<number, string> = {
  1: 'ethereum',
  137: 'matic',
  42161: 'arbitrum',
  10: 'optimism',
  8453: 'base',
  7777777: 'zora',
  56: 'bsc',
  43114: 'avalanche',
}

export const openseaAssetUrl = (
  chainId: number,
  contract?: string,
  tokenId?: string
): string | null => {
  const slug = OPENSEA_CHAIN_SLUGS[chainId]
  if (!slug || !contract || !tokenId) return null
  return `https://opensea.io/assets/${slug}/${contract}/${tokenId}`
}

type Props = {
  contract?: string
  tokenId?: string
  buttonCss?: CSS
  buttonProps?: ComponentProps<typeof Button>
  label?: string
}

// Outbound purchase link — the relaunch browse/portfolio mode has no native
// execution, so buying happens on OpenSea in a new tab.
const OpenSeaButton: FC<Props> = ({
  contract,
  tokenId,
  buttonCss,
  buttonProps,
  label = 'Buy on OpenSea',
}) => {
  const marketplaceChain = useMarketplaceChain()
  const url = openseaAssetUrl(marketplaceChain.id, contract, tokenId)

  if (!url) return null

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'contents' }}
    >
      <Button css={buttonCss} color="primary" {...buttonProps}>
        {label}
      </Button>
    </a>
  )
}

export default OpenSeaButton
